import { render, staticRenderFns } from "./performanceInside.vue?vue&type=template&id=5a5d2c50&scoped=true&"
import script from "./performanceInside.vue?vue&type=script&lang=js&"
export * from "./performanceInside.vue?vue&type=script&lang=js&"
import style0 from "./performanceInside.vue?vue&type=style&index=0&id=5a5d2c50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5d2c50",
  null
  
)

export default component.exports